import { Box } from "rebass";

export const DropDown = ({
	options = [],
	width,
	value,
	...rest
}) => {
	return (
		<Box
			as="div"
			css={`
				position: relative;
				width: ${width || `350px`};
				&:after {
					content: "\f078";
					font: normal normal normal 17px/1 FontAwesome;
					color: #fff;
					background-color: #008efa;
					right: 2px;
					top: 3px;
					height: 33px;
					padding: 10px 14px 0px 12px;
					border-left: 1px solid grey;
					border-radius: 0 6px 6px 0;
					position: absolute;
					pointer-events: none;
				}
				select::-ms-expand {
					display: none;
				}
			`}
		>
			<Box
				as="select"
				{...rest}
				width={`${width || `350px`}`}
				value={value}
				css={`
					-webkit-appearance: none;
					-moz-appearance: none;
					appearance: none;
					display: block;
					height: 50px;
					float: right;
					margin: 0px 0px;
					padding: 0px 15px;
					font-size: 16px;
					line-height: 1.75;
					color: #333;
					background-color: #ffffff;
					background-image: none;
					border: 1px solid lightgrey;
					-ms-word-break: normal;
					word-break: normal;
					border-radius: 6px;

					&:disabled {
						background-color: transparent;
						background-image: url("/static/icons/misc/stripe.svg");
						border: 1px dashed #008efa;
						&::placeholder {
							color: grey;
						}
					}
				`}
				mr={0}
			>
				{options.map(({ title, id }) => (
					<option key={id}>{title}</option>
				))}
			</Box>
		</Box>
	);
};
